import { render, staticRenderFns } from "./FileArrowDownIcon.vue?vue&type=template&id=d418e1f8&"
import script from "./FileArrowDownIcon.vue?vue&type=script&lang=js&"
export * from "./FileArrowDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports